// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__HcrIh","clinicsSelect":"TableHeading_clinicsSelect__3Ghc-"};